import {FontSizes, hs, isPhone, vs} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';
import {Dimensions, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  // Full-width page (no centred max-width cap) with tighter gutters on phones.
  container: {
    flex: 1,
    width: '100%',
    paddingHorizontal: isPhone ? vs(12) : vs(24),
    paddingTop: isPhone ? vs(12) : vs(20),
    paddingBottom: vs(28),
  },
  header: {
    fontSize: isPhone ? FontSizes[18] : FontSizes[20],
    textAlign: isPhone ? 'left' : 'center',
    fontWeight: 'bold',
    color: '#4D3F37',
  },
  // Field groups render as cards rather than bare stacks, so "Your Personal
  // Profile" / "Your Chess Profile" read as distinct blocks on the cream page.
  section: {
    marginBottom: vs(16),
    paddingHorizontal: isPhone ? vs(14) : vs(20),
    paddingTop: isPhone ? vs(16) : vs(18),
    paddingBottom: isPhone ? vs(16) : vs(20),
    backgroundColor: CCColors.White,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: CCColors.BorderLight,
    shadowColor: CCColors.Primary.Dark,
    shadowOpacity: 0.05,
    shadowRadius: 8,
    shadowOffset: {width: 0, height: 2},
  },
  sectionHeader: {
    fontSize: FontSizes[15],
    fontWeight: '600',
    color: CCColors.TextColor.Dark,
    marginBottom: vs(4),
    letterSpacing: 0.2,
  },
  row: {
    flexDirection: isPhone ? 'column' : 'row',
    justifyContent: 'flex-start',
    alignItems: isPhone ? 'stretch' : 'flex-start',
    flexWrap: 'wrap',
    // gap instead of per-field negative margins: percentage flex-bases plus
    // margins overflow the row and cause lopsided wrapping.
    gap: isPhone ? 0 : vs(16),
  },
  input: {
    flexGrow: 1,
    flexShrink: 1,
    // 31% x3 + two 16px gaps fills the row; minWidth drops it to 2-up, then
    // 1-up, as the viewport narrows.
    flexBasis: isPhone ? '100%' : '31%',
    minWidth: isPhone ? '100%' : vs(220),
    marginVertical: isPhone ? vs(8) : vs(6),
  },
  avatarGrid: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: vs(12),
  },
  avatarPreview: {
    alignItems: 'center',
    marginTop: vs(12),
  },
  avatarName: {
    fontSize: FontSizes[14],
    fontWeight: 'bold',
    marginVertical: vs(4),
  },
  avatarTagline: {
    fontSize: FontSizes[12],
    color: '#6D6D6D',
    textAlign: 'center',
  },
  errorText: {
    color: CCColors.Red,
    textAlign: 'center',
    marginVertical: vs(10),
    backgroundColor: '#FFEFEE',
    borderRadius: 10,
    paddingVertical: vs(10),
    paddingHorizontal: vs(14),
    overflow: 'hidden',
  },
  successText: {
    color: CCColors.Green,
    textAlign: 'center',
    marginVertical: vs(10),
    backgroundColor: '#E4F6EB',
    borderRadius: 10,
    paddingVertical: vs(10),
    paddingHorizontal: vs(14),
    overflow: 'hidden',
  },
  buttonContainer: {
    flexDirection: isPhone ? 'column' : 'row',
    alignItems: isPhone ? 'stretch' : 'center',
    justifyContent: isPhone ? 'flex-start' : 'flex-end',
    gap: isPhone ? vs(10) : vs(12),
    flexWrap: 'wrap',
    marginTop: vs(4),
    marginBottom: vs(24),
    paddingTop: vs(16),
    borderTopWidth: 1,
    borderTopColor: CCColors.BorderLight,
  },
  saveButton: {
    backgroundColor: '#FACF47',
    borderRadius: vs(24),
    paddingVertical: vs(12),
    paddingHorizontal: vs(48),
  },
  item: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    margin: vs(4),
    padding: vs(8),
    backgroundColor: '#FAF6EB',
    borderRadius: vs(8),
  },
  itemInvisible: {
    backgroundColor: 'transparent',
  },
  itemText: {
    fontSize: FontSizes[12],
    textAlign: 'center',
  },
  // Tab related styles
  tabContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: vs(16),
  },
  tabButton: {
    marginHorizontal: vs(6),
    minWidth: vs(160),
  },
  tabContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  identityCard: {
    flexDirection: isPhone ? 'column' : 'row',
    alignItems: isPhone ? 'flex-start' : 'center',
    gap: isPhone ? 10 : 14,
    backgroundColor: '#fff',
    borderRadius: 14,
    padding: 18,
    borderWidth: 1,
    borderColor: CCColors.BorderLight,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  identityAvatar: {
    width: 52,
    height: 52,
    borderRadius: 26,
    backgroundColor: CCColors.Primary.Brown,
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabs: {
    width: isPhone ? '100%' : '34%',
    marginBottom: vs(18),
    flexDirection: 'row',
    justifyContent: 'space-around',
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  tab: {
    flex: 1,
    paddingVertical: 10,
    alignItems: 'center',
  },
  activeTab: {
    borderBottomWidth: 3,
    borderBottomColor: '#FFC107',
  },
  tabText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#333',
  },
});
